import React, { Dispatch, createContext, useState } from 'react';

const defaultSetIsSupportMfeOpen: Dispatch<React.SetStateAction<
  boolean
>> = () => {};

const SupportContactMfeContext = createContext({
  isSupportMfeOpen: false,
  setIsSupportMfeOpen: defaultSetIsSupportMfeOpen
});

// This is too simple of a context provider to justify existing.
// The only reason this exists is because the MFE can't figure out how to close itself.
const SupportContactMfeContextProvider: React.FC<React.PropsWithChildren<{}>> = ({
  children
}) => {
  const [isSupportMfeOpen, setIsSupportMfeOpen] = useState(false);

  return (
    <SupportContactMfeContext.Provider
      value={{ isSupportMfeOpen, setIsSupportMfeOpen }}
    >
      {children}
    </SupportContactMfeContext.Provider>
  );
};

export default SupportContactMfeContext;
export { SupportContactMfeContextProvider };
